<template>
  <ShopifyOrders v-if="SHOPIFYBRANDS.includes(BRAND)"></ShopifyOrders>
  <OpenCartOrders v-else></OpenCartOrders>
</template>

<script>
import { ShopifyOrders, OpenCartOrders } from "./partials";
export default {
  name: "orders",
  components: { ShopifyOrders, OpenCartOrders }
};
</script>
